module.exports = __webpack_public_path__ + "media/images/creator/home/about-02@2x-554222603339668e8d7ac8fdb73e4f10.png";